export function parseWidgetSelection(selection) {
    return {
        eventId: selection.eventId,
        marketId: selection.marketId,
        selectionId: selection.id,
        eventName: selection.eventName,
        marketName: selection.marketName,
        selectionName: selection.label,
        points: selection.points,
        outcomeType: selection.outcomeType,
        prePackId: selection.prePackId,
    };
}
//# sourceMappingURL=parseWidgetSelection.js.map